{
  "name": "northai-app",
  "version": "2.0.79",
  "sideEffects": false,
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "build:dev": "cp src/environments/environment.dev.ts src/environments/environment.ts && ng build --configuration=development",
    "build:staging": "cp src/environments/environment.staging.ts src/environments/environment.ts && ng build --configuration=staging",
    "build:prod": "cp src/environments/environment.prod.ts src/environments/environment.ts && ng build --configuration=production",
    "bump": "npm version patch --no-git-tag-version",
    "deploy:dev": "npm run bump && firebase use dev && npm run build:dev && firebase deploy --only hosting:base -P dev",
    "deploy:staging": "firebase use staging && npm run build:staging && firebase deploy --only hosting:base -P staging",
    "deploy:prod": "firebase use prod && npm run build:prod && firebase deploy --only hosting:base -P prod"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.4",
    "@angular/cdk": "^20.2.2",
    "@angular/common": "^20.2.4",
    "@angular/compiler": "^20.2.4",
    "@angular/core": "^20.2.4",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.2.4",
    "@angular/platform-browser": "^20.2.4",
    "@angular/platform-browser-dynamic": "^20.2.4",
    "@angular/router": "^20.2.4",
    "@angular/service-worker": "^20.2.4",
    "@primeuix/themes": "^1.2.5",
    "@supabase/supabase-js": "^2.89.0",
    "@tailwindcss/container-queries": "^0.1.1",
    "angular-plotly.js": "^6.0.0",
    "chart.js": "^4.5.0",
    "chartjs-plugin-scroll-bar": "^1.3.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "circle-flags": "github:kapowaz/circle-flags",
    "date-fns": "^4.1.0",
    "echarts": "^6.0.0",
    "google-libphonenumber": "^3.2.40",
    "graphology": "^0.26.0",
    "graphology-components": "^1.5.4",
    "graphology-layout": "^0.6.1",
    "graphology-layout-forceatlas2": "^0.10.1",
    "jspdf": "^4.2.1",
    "marked": "^15.0.7",
    "mermaid": "^11.15.0",
    "motion": "^10.18.0",
    "ngx-device-detector": "^10.1.0",
    "ngx-echarts": "^20.0.2",
    "ngx-markdown": "^20.1.0",
    "plotly.js-dist-min": "^3.0.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "sigma": "^3.0.2",
    "tailwindcss-primeui": "^0.3.4",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "veg": "^1.0.0",
    "vega-embed": "^7.1.0",
    "vega-lite": "^6.4.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.2.2",
    "@angular/cli": "^20.2.2",
    "@angular/compiler-cli": "^20.2.4",
    "@tailwindcss/typography": "^0.5.16",
    "@types/jasmine": "~5.1.0",
    "@types/plotly.js-dist-min": "^2.3.4",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.2"
  }
}
